















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'

@Component({
  components: { AlertNotification, BaseButton }
})
export default class PanelContentItemLatencyAlarmMessage extends Vue {
  response: { message: string, show: boolean } = { message: '', show: false }

  mounted() {
    this.getMessage()
  }

  async getMessage() {
    try {
      const response = await fetch(Ziggy
        .route('panel.content.items.check_items_purchased_count')
        .toString())
      this.response = await response.json()
    } catch (err) {
      return false
    }
  }

}
